export default __webpack_public_path__ + "static/stile_x_explainers-03ec97413bb7f1384ecc712d3698d440.mp4";